// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { ArrowUpRight as RawArrowUpRight } from "lucide-react";
export const ArrowUpRight = /* @__PURE__ */ createIcon(RawArrowUpRight, "ArrowUpRight", 2);
